import { NgClass } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';

@Component({
  selector: 'ui-page-content-layout',
  templateUrl: './page-content-layout.component.html',
  styleUrl: './page-content-layout.component.scss',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [NgClass, NzDrawerModule, NzIconModule],
})
export class UIPageContentLayout {
  @Input() sidebarVisible = false;
  @Output() sidebarVisibleChange = new EventEmitter<boolean>();

  setSidebarVisible(value: boolean): void {
    this.sidebarVisible = value;
    this.sidebarVisibleChange.emit(this.sidebarVisible);
  }
}
